import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as LogbookAppReducer from '../logbook.reducer';
import * as ObjectActions from './formio-e-signature.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import * as AppActions from '../app/actions';
import { FormioESignatureService } from './formio-e-signature.service';
import { IGetOneResponse } from '../../shared/model/interface/crud-response-interface.model';
import { IFormioESignEventResponse } from './formio-e-signature.model';

@Injectable()
export class FormioESignatureEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<LogbookAppReducer.LogbookAppState>,
    private readonly formioESignatureService: FormioESignatureService,
  ) {}

  createFormioESignEventEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.CREATE_FORMIO_E_SIGN),
      switchMap((objectData: ObjectActions.CreateFormioESign) => {
        this.store.dispatch(new AppActions.ShowLoader());
        return this.formioESignatureService.createFormioESignData(objectData.payload).pipe(
          switchMap((response: IGetOneResponse<IFormioESignEventResponse>) => {
            return of(new ObjectActions.CreateFormioESignCompleted(response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  deleteFormioESignEventEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.DELETE_FORMIO_E_SIGN),
      switchMap((objectData: ObjectActions.DeleteFormioESign) => {
        this.store.dispatch(new AppActions.ShowLoader());
        return this.formioESignatureService
          .deleteFormioESignData(objectData.id, objectData.issuerAndReason, objectData.payload)
          .pipe(
            switchMap((response: IGetOneResponse<IFormioESignEventResponse>) => {
              return of(new ObjectActions.DeleteFormioESignCompleted(response), new AppActions.HideLoader());
            }),
            catchError((errorRes) => {
              return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
            }),
          );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );
}
